import { Component, OnInit, Inject, EventEmitter, Output, Input } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl } from '@angular/forms';
import { CommonService } from '../../core/service/common-service/common.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
	selector: 'app-lost-customer-lead-update-dialog',
	templateUrl: './lost-customer-lead-update-dialog.component.html',
	styleUrls: [ './lost-customer-lead-update-dialog.component.css' ]
})
export class LostCustomerLeadUpdateDialogComponent implements OnInit {


	vin: any
	customerCode: any
	leadStatus: FormControl = new FormControl('');
	leadStatusRemarks: FormControl = new FormControl('');
	countryCode: string;
	userId: string;
	chassisArray: string[] = [];
	selectedChassis: string[] = [];

	constructor(
		public dialog: MatDialog,
		private router: Router,
		private commonService: CommonService,
		private toastr: ToastrService,
		private dialogRef: MatDialogRef<LostCustomerLeadUpdateDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any

	) {
		this.customerCode = data.customerCode;
	}

	ngOnInit() {
		this.countryCode = localStorage.getItem('countryCode');
		this.userId = localStorage.getItem('userId');
		this.getWMVehicleDetails();
	}

	getWMVehicleDetails() {
		this.commonService.LCWorkshopManagerLeadsVehicleDetails(this.customerCode).subscribe((res) => {
			if (res['responseCode'] == 0 && res['responseData'] != undefined) {
				if (res['responseData'].length != 0) {
					res['responseData'].forEach(element => {
						if (element.registrationNumber != null || element.registrationNumber != "") {
							this.chassisArray.push(element.registrationNumber);
						}
						else {
							this.chassisArray.push(element.chassisNumber);
						}
					});
				} else {
					this.toastr.error("No vehicle Found", "Error");
				}
			} else {
				this.toastr.error(res['message'], "Error");
			}
		}, err => {
			this.toastr.error('Something went wrong, Please try again.', 'Error');
		});
	}

	onclose() {
		this.dialogRef.close();
	}

	updateLeadStatus() {
		this.vin = this.selectedChassis.join(";");
		if (this.leadStatus.valid && this.leadStatusRemarks.valid && this.vin != "") {
			this.commonService
				.updateLeadStatus(
					this.customerCode,
					this.vin,
					this.leadStatus.value,
					this.leadStatusRemarks.value,
					this.userId
				)
				.subscribe(
					(res) => {
						if (res['responseCode'] == 0 && res['responseData'] != undefined) {
							this.toastr.info('Status Updated', 'Success');
							if (res['message'] != null || res['message'] != "") {
								this.dialogRef.close(-1);
							}
						} else {
							this.toastr.error('Status Not Updated', 'Error');
							this.onclose();
						}
					},
					(err) => {
						this.toastr.error('Something went wrong, Please try again.', 'Error');
						this.onclose();
					}
				);

		} else {
			this.toastr.error("Please fill required fields");
		}
	}
}

export function openLostCustomerLeadUpdateDialog(dialog: MatDialog, customerCode) {
	const config = new MatDialogConfig();
	config.disableClose = true;
	config.autoFocus = true;
	config.width = '500px';
	config.height = '350px';
	config.data = {
		customerCode: customerCode,
	};
	const dialogRef = dialog.open(LostCustomerLeadUpdateDialogComponent, config);
	return dialogRef.afterClosed();
}
